import type { QueryClient } from '@tanstack/react-query';
import { create } from 'zustand';
import { updateProfileUiFlags } from '@/api/profiles';
import { MY_PROFILE_QUERY_KEY } from '@/constants';
import { trackUmamiEvent } from '@/helpers/analytics';
import type { ProfileDto } from '@/types/profiles';

const COUNTRY_MODAL_VOTE_THRESHOLD = 20;

interface CountryPromptModalStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useCountryPromptModalStore = create<CountryPromptModalStore>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

/**
 * Call after successful vote. If user has total_predictions >= 20, no country set,
 * and hasn't seen the country modal, shows it and sets ui_flags on backend.
 */
export function checkAndMaybeShowCountryModal(queryClient: QueryClient): void {
  const profile = queryClient.getQueryData<ProfileDto>(MY_PROFILE_QUERY_KEY);
  if (!profile) return;
  if ((profile.total_predictions ?? 0) < COUNTRY_MODAL_VOTE_THRESHOLD) return;
  if (profile.country != null && profile.country !== '') return;
  if (profile.ui_flags?.country_modal_shown === true) return;

  useCountryPromptModalStore.getState().setOpen(true);
  trackUmamiEvent('country_modal_shown', { totalPredictions: profile.total_predictions });

  updateProfileUiFlags({ flag: 'country_modal_shown' })
    .then((res) => {
      queryClient.setQueryData(MY_PROFILE_QUERY_KEY, res.data);
    })
    .catch(() => {
      // Fire-and-forget; user will see modal again on next vote until backend succeeds
    });
}
